import { Component, HostListener, Input, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthService } from 'src/app/@core/services/auth.service';
import { environment } from 'src/environments/environment';
import { RedirectParameter } from '../../model/redirect-parameter.model';
import { NavegationService } from '../../services/navegation.service';
import { MicrosoftGraphService } from 'src/app/@core/services/microsoft-graph.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  private readonly sidenavStateKey = 'midas.sidenav.pinned';

  @Input() public items?: Array<any> = [];
  params: any;
  public production: boolean = false;
  public photo: string;
  public name: string;
  public openDropdownKey: string | null = null;

  @Input() public showStock: boolean;

  constructor(
    private authService: AuthService,
    private navegationService: NavegationService,
    private route: ActivatedRoute,
    private graphService: MicrosoftGraphService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.production = environment.production;

    this.route.params.subscribe(_params => this.params = _params);

    this.graphService.getPhoto().subscribe(
      response => this.photo = response, errors =>
      this.photo = this.graphService.PhotoDefault
    );

    this.name = this.authService.getClaims().ExternalIdEmail;

    if (window.innerWidth < 900) {
      this.isMobileResolution = true;
    } else {
      this.isMobileResolution = false;
    }

    this.syncSidenavStateFromBody();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.syncSidenavStateFromBody();
      }
    });

  }

  public toggleDropdown(key: string, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.openDropdownKey = this.openDropdownKey === key ? null : key;
  }

  public closeDropdowns(): void {
    this.openDropdownKey = null;
  }

  public isDropdownOpen(key: string): boolean {
    return this.openDropdownKey === key;
  }

  habilitarChat(): boolean {
    switch (this.authService.getClaims().ExternalIdEmail) {
      case "rodrigo.germano@teadit.com":
      case "jorge.carvalho@teadit.com":
      case "marcelo.mano@teadit.com":
      case "diego.cunha@teadit.com":
      case "ricardo.henrique@teadit.com":
      case "ana.pupo@teadit.com":
      case "douglas.maeda@teadit.com":
      case "carlos.girao@teadit.com":
      case "leonardo.roca@teadit.com":
        return true;
        break;
      default:
        return false;
        break;
    }
  }

  public logout(): void {
    this.authService.logout();
  }

  redirectHome() {
    this.router.navigate([`/`]);
  }

  public setUrl(module: string, parameter: string, value: string): void {

    this.navegationService.addParameter(module, new RedirectParameter(parameter, value));
    this.navegationService.redirect();
  }

  public getValue(parameter): string {

    if (this.params[parameter] !== undefined) {
      let _display = this.items.find(x => x.value == parameter).children.find(x => x.value == this.params[parameter])?.display;

      if (_display == undefined)
        return '';

      return _display;
    }

    return '';
  }

  isMobileResolution: boolean;

  @HostListener("window:resize", ["$event"])
  isMobile(event) {
    if (window.innerWidth < 900) {
      this.isMobileResolution = true;
    } else {
      this.isMobileResolution = false;
    }
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    this.closeDropdowns();
  }

  sidenavOpen: boolean = false;

  private syncSidenavStateFromBody(): void {
    this.sidenavOpen = document.body.classList.contains('g-sidenav-pinned');
  }

  private setSidenavState(isPinned: boolean): void {
    const body = document.getElementsByTagName('body')[0];
    const sidenavTogglers = Array.from(document.getElementsByClassName('sidenav-toggler'));
    body.classList.remove('g-sidenav-pinned');
    body.classList.remove('g-sidenav-hidden');
    body.classList.remove('g-sidenav-show');

    if (isPinned) {
      body.classList.add('g-sidenav-pinned');
      sidenavTogglers.forEach(toggler => toggler.classList.add('active'));
    } else {
      body.classList.add('g-sidenav-hidden');
      sidenavTogglers.forEach(toggler => toggler.classList.remove('active'));
    }

    this.sidenavOpen = isPinned;

    try {
      localStorage.setItem(this.sidenavStateKey, String(isPinned));
    } catch {
      // Ignore storage errors to keep menu functional.
    }
  }

  openSidebar() {
    this.setSidenavState(!document.body.classList.contains('g-sidenav-pinned'));
  }
  toggleSidenav() {
    this.setSidenavState(!document.body.classList.contains('g-sidenav-pinned'));
  }

}
